import { Color } from '@tmh-website/shared/colors';
import StyledTypo from '@tmh-website/styles/typo';
import { StyledButton } from '@tmh-website/ui/Button';
import { FormElementThemeColor, formElementThemes } from '@tmh-website/ui/FormElements';
import styled, { css } from 'styled-components';
import { environmentSelectButtonBordeThemes } from './EnvironmentSelectButton.theme';

interface ContainerProps {
  $themeColorColor: FormElementThemeColor;
  $hasIconLeft: boolean;
  $borderColor?: Color;
  $isSmall?: boolean;
}

export const Container = styled.button<ContainerProps>`
  ${StyledTypo.h6Css};
  ${StyledButton.ButtonBase};
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  min-height: ${props => props.theme.btnMinHeight};
  padding: ${props => props.theme.btnSmallPadding};
  ${props => props.$hasIconLeft && `padding-left: 16px;`}
  color: ${props => props.theme.color[formElementThemes[props.$themeColorColor].text]};
  background-color: ${props => props.theme.color[formElementThemes[props.$themeColorColor].background.normal]};
  border: 2px solid
    ${props =>
      props.theme.color[
        props.$borderColor
          ? environmentSelectButtonBordeThemes[props.$borderColor].normal
          : formElementThemes[props.$themeColorColor].border.normal
      ]};
  border-radius: ${props => props.theme.borderRadius.large};
  transition: border-color ${props => props.theme.transitionTiming};
  ${props =>
    props.$isSmall &&
    css`
      padding: 4px 10px;
    `}

  &:hover {
    border-color: ${props =>
      props.theme.color[
        props.$borderColor
          ? environmentSelectButtonBordeThemes[props.$borderColor].hover
          : formElementThemes[props.$themeColorColor].border.hover
      ]};
  }

  &:active {
    border-color: ${props =>
      props.theme.color[
        props.$borderColor
          ? environmentSelectButtonBordeThemes[props.$borderColor].active
          : formElementThemes[props.$themeColorColor].border.active
      ]};
  }

  > * {
    margin-right: ${props => props.theme.gap.xSmall};

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const Label = styled.span`
  display: inline-flex;
  align-items: center;

  > span {
    margin-left: 10px;
  }
`;
